import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTitle: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.chart-title',
		defaultMessage: 'Weekly comparison',
		description: 'The bar chart title where we show historical cycle time data weekly',
	},
	titleHelpTooltip: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.title-help-tooltip',
		defaultMessage:
			'A 12-week time feed that helps you compare and analyze your weekly cycle times and evaluate how quickly you are delivering value to your customers.',
		description:
			'Tooltip explaining what this chart is for when mouse is hovered on the question mark icon beside the title of the chart.',
	},
	titleHelpTooltipLabel: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.title-help-tooltip-label',
		defaultMessage: 'More info about weekly comparison chart',
		description:
			'Label for the tooltip explaining what this chart is for when mouse is hovered on the question mark icon beside the title of the chart.',
	},
});
